const formatDateForInput = (dateString) => {
        if (!dateString) return "";
        
        try {
            // Handle DD/MM/YYYY format
            if (typeof dateString === 'string' && dateString.includes('/')) {
                const parts = dateString.split('/');
                if (parts.length === 3) {
                    const [day, month, year] = parts;
                    // Convert DD/MM/YYYY to YYYY-MM-DD
                    const isoDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
                    return isoDate;
                }
            }
            
            // Handle other formats
            const date = new Date(dateString);
            if (!isNaN(date.getTime())) {
                return date.toISOString().slice(0, 10);
            }
            
            return "";
        } catch {
            return "";
        }
    };
export default formatDateForInput;    